import { useState } from 'react'
import MemberDetail from './MemberDetail'

export default function MembersTable({ members, chapters, onRefresh }) {
  const [selected, setSelected] = useState(null)

  if (members.length === 0) {
    return <div className="text-gray-500 text-sm uppercase tracking-widest text-center py-10">No members found</div>
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        {members.map((member) => (
          <div
            key={member.id}
            onClick={() => setSelected(member)}
            className="bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/10 hover:border-green-500/50 dark:hover:border-green-600/50 hover:bg-green-50 dark:hover:bg-green-900/10 transition-all cursor-pointer px-6 py-4 flex items-center gap-4"
          >
            <div className="w-10 h-10 rounded-full overflow-hidden bg-green-900/50 border border-green-700/50 flex items-center justify-center text-white font-black text-sm shrink-0">
              {member.profile_photo ? (
                <img src={member.profile_photo} alt="Profile" className="w-full h-full object-cover" />
              ) : (
                member.full_name?.split(' ').map(n => n[0]).join('').toUpperCase()
              )}
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-1 flex-wrap">
                <span className="font-black text-gray-900 dark:text-white text-sm uppercase tracking-tight">
                  {member.full_name}
                </span>
                <span className={`text-xs font-bold uppercase tracking-widest px-2 py-0.5 shrink-0 ${
                  member.status === 'active'
                    ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400'
                    : 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 dark:text-yellow-400'
                }`}>
                  {member.status}
                </span>
              </div>
              <div className="flex items-center gap-4 text-xs text-gray-500 flex-wrap">
                <span className="text-green-600 dark:text-green-400 font-bold tracking-wider">{member.membership_id}</span>
                <span className="hidden sm:block">{member.email}</span>
                <span className="hidden md:block">{member.chapters?.name || 'No chapter'}</span>
              </div>
            </div>

            <div className="hidden lg:block text-xs text-gray-500 shrink-0">
              {new Date(member.joined_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
            </div>

            <div className="shrink-0 flex items-center gap-2 text-green-600 dark:text-green-400">
              <span className="text-xs font-bold uppercase tracking-widest hidden sm:block">View</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <MemberDetail member={selected} onClose={() => setSelected(null)} onRefresh={onRefresh} chapters={chapters} />
      )}
    </>
  )
}